import React from 'react';
import Joi from "joi-browser";
import { Popover, OverlayTrigger } from "react-bootstrap";
import Phone_textbox from "./Phone_textbox";
import SSN_textbox from "./SSN_textbox";
import Other_textbox from "./Other_textbox";
import { formatPhoneNumber, formatSSNNumber } from '../../services/appService';
import Controls from '../controls/Controls';
import { FormControl, FormHelperText } from '@mui/material';

export default function TextBox(props) {

    const { controleId,
        comp,
        stateData: data,
        stateErrors: errors,
        stateSchema: schema,
        codeIsVerified,
        isDisabled,
        handleChange,
        handeOnChange,
        getEvaluatedValue
    } = props;

    const getPopover = (notes) => {
        const popover = (
            <Popover id="popover-basic" style={{ minWidth: "500px" }}>
                <Popover.Title as="h4">Rule Expression</Popover.Title>
                <Popover.Content>{notes}</Popover.Content>
            </Popover>
        );
        return (
            <React.Fragment>
                <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                    <button className="btn btn-sm btn-outline-success ml-2">
                        <i className="fa fa-eye mr-2"></i>View Rule
                    </button>
                </OverlayTrigger>
            </React.Fragment>
        );
    };

    const handleEncryptDecryptedOnChange = (name, valueArray) => {
        // let decValue = "";
        // for (let index = 0; index < valueArray.length; index++) {
        //     const element = valueArray[index];
        //     decValue += element;
        // }
        const input = { name: name, value: valueArray };
        handleChange(input);
    };

    const handePhoneOnChange = ({ currentTarget: input }) => {
        input.value = input.value.replace(/[^\d]/g, "");
        if (input.value.length <= 10)
            handleChange(input);
    };

    const handeSsnOnChange = ({ currentTarget: input }) => {
        input.value = input.value.replace(/[^\d]/g, "");
        if (input.value.length <= 9)
            handleChange(input);
    };

    let inputType = "";
    if (comp?.attributeDataTypes?.type)
        inputType = comp.attributeDataTypes.type;

    if (inputType === "phone" || inputType === "mobile") {
        schema[controleId] = !comp.isRequired
            ? Joi.string()
                .length(10)
                .options({
                    language: {
                        string: {
                            length: comp.label + " must be 10 digits.",
                        },
                    },
                })
                .label(comp.label)
            : Joi.string()
                .length(10)
                .options({
                    language: {
                        string: {
                            length: comp.label + " must be 10 digits.",
                        },
                    },
                })
                .required()
                .label(comp.label);
    }

    if (inputType === "ssn") {
        schema[controleId] = !comp.isRequired
            ? Joi.string()
                .length(9)
                .options({
                    language: {
                        string: {
                            length: comp.label + " must be 9 digits.",
                        },
                    },
                })
                .label(comp.label)
            : Joi.string()
                .length(9)
                .options({
                    language: {
                        string: {
                            length: comp.label + " must be 9 digits.",
                        },
                    },
                })
                .required()
                .label(comp.label);
    }

    if (inputType === "email") {
        schema[controleId] = !comp.isRequired
            ? Joi.string().email().label(comp.label)
            : Joi.string().email().required().label(comp.label);
    }

    return (
        <>
            {comp?.encryptionValidate ? (
                <>
                    {inputType === "ssn" && (
                        <SSN_textbox
                            value={!data[controleId] ? "" : data[controleId]}
                            label={comp.label}
                            isDisabled={isDisabled}
                            name={controleId}
                            handleOnChange={handleEncryptDecryptedOnChange}
                            codeIsVerified={codeIsVerified}
                            errors={errors}
                            required={comp.isRequired}
                            cssclass={comp?.cssclass}
                        />
                    )}
                    {(inputType === "phone" || inputType === "mobile") && (
                        <Phone_textbox
                            value={!data[controleId] ? "" : data[controleId]}
                            label={comp.label}
                            isDisabled={isDisabled}
                            name={controleId}
                            handleOnChange={handleEncryptDecryptedOnChange}
                            codeIsVerified={codeIsVerified}
                            errors={errors}
                            required={comp.isRequired}
                            cssclass={comp?.cssclass}
                        />
                    )}
                    {(inputType === "" || inputType === "email" || inputType === "number") && (
                        <Other_textbox
                            value={!data[controleId] ? "" : data[controleId]}
                            label={comp.label}
                            isDisabled={isDisabled}
                            name={controleId}
                            handleOnChange={handleEncryptDecryptedOnChange}
                            codeIsVerified={codeIsVerified}
                            errors={errors}
                            required={comp.isRequired}
                            cssclass={comp?.cssclass}
                        />
                    )}
                </>
            ) : (
                <FormControl fullWidth variant="outlined" error={errors[controleId] ? true : false}>
                    {inputType === "ssn" && (
                        <Controls.Input
                            required={comp.isRequired}
                            name={controleId}
                            label={comp.label}
                            type={`text`}
                            disabled={isDisabled}
                            value={formatSSNNumber(!data[controleId] ? "" : data[controleId])}
                            onChange={handePhoneOnChange}
                            className={`${comp?.cssclass ? "" : comp.cssclass}`}
                        />
                    )}

                    {(inputType === "phone" || inputType === "mobile") && (
                        <Controls.Input
                            required={comp.isRequired}
                            name={controleId}
                            label={comp.label}
                            type={`text`}
                            disabled={isDisabled}
                            value={formatPhoneNumber(!data[controleId] ? "" : data[controleId])}
                            onChange={handePhoneOnChange}
                            className={`${comp?.cssclass ? "" : comp.cssclass}`}
                        />
                    )}

                    {(inputType === "" || inputType === "email" || inputType === "number") && (
                        <React.Fragment>
                            <Controls.Input
                                required={comp.isRequired}
                                name={controleId}
                                label={comp.label}
                                type={`${inputType === "number" ? "number" : "text"}`}
                                value={!data[controleId] ? "" : data[controleId]}
                                onChange={handeOnChange}
                            />
                        </React.Fragment>
                    )}
                    {errors[controleId] && <FormHelperText>{errors[controleId]}</FormHelperText>}
                </FormControl>
            )}
        </>
    )
}